
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import T from '../../lang';
import VueRecaptcha from 'vue-recaptcha';
import omegaup_Login from './Login.vue';
import omegaup_Signup from './Signup.vue';

export enum AvailableTabs {
  Login = 'login',
  Signup = 'signup',
}

@Component({
  components: {
    'omegaup-login': omegaup_Login,
    'omegaup-signup': omegaup_Signup,
    'vue-recaptcha': VueRecaptcha,
  },
})
export default class Signin extends Vue {
  @Prop() validateRecaptcha!: boolean;
  @Prop() facebookUrl!: string;
  @Prop({ default: '' }) githubClientId!: string;
  @Prop({ default: null }) githubState!: string | null;
  @Prop() googleClientId!: string;
  @Prop() hasVisitedSection!: boolean;
  @Prop({ default: false }) useSignupFormWithBirthDate!: boolean;
  @Prop({ default: AvailableTabs.Login }) initialActiveTab!: AvailableTabs;

  T = T;
  AvailableTabs = AvailableTabs;
  activeTab: AvailableTabs = this.initialActiveTab;

  @Watch('initialActiveTab')
  onInitialActiveTabChanged(newValue: AvailableTabs): void {
    this.activeTab = newValue;
  }

  setActiveTab(tab: AvailableTabs): void {
    this.activeTab = tab;
    window.location.hash = `#${tab}`;
  }
}
